<template>
    <div class="position-box">
        <div class="head">
            <img class="back" v-if="theme" src="@/assets/theme/icon_back.png" @click="back" alt="">
            <img class="back" v-else src="@/assets/icon_back.png" @click="back" alt="">
            <div class="title">{{$t('my.hc')}}</div>
        </div>
        <div class="cotainer help">
            <ul class="ul-box" v-if="lang == 'ar'">
                <li class="li" v-for="(item,index) in xsbkArr" @click="goDetail(item.id)" :key="index">
                    <img class="arrow" v-if="theme" src="@/assets/theme/icon_back.png" alt="">
                    <img class="arrow" v-else src="@/assets/alb/icon_back.png" alt="">
                    <div class="text">{{item.title}}</div>
                </li>
            </ul>
            <ul class="ul-box" v-else>
                <li class="li" v-for="(item,index) in xsbkArr" @click="goDetail(item.id)" :key="index">
                    <div class="text">{{item.title}}</div>
                    <img class="arrow" v-if="theme" src="@/assets/theme/jiantou_white.png" alt="">
                    <img class="arrow" v-else src="@/assets/user/jiantou.png" alt="">
                </li>
            </ul>
            <!-- 暂无数据 -->
            <div class="null-box" v-show="hasData">
              <img class="icon" v-if="!theme" src="@/assets/Null.png" alt="">
              <img class="icon" v-else src="@/assets/theme/wushuju.png" alt="">
              <p class="text">{{$t('zwsj.title')}}</p>
            </div>
        </div>
    </div>
</template>

<script>
import navBar from '@/components/NavBar.vue'
let that = this;
export default {
    name: 'help',
    data () {
        return {
          theme: false,
          hasData: false,
          xsbkArr:[],
          theme: false,
          curDataLength: 10,
          page: 1,
          lang: 'en'
        }
    },
    beforeCreate(){
        that = this;
    },
    created(){
      this.theme = JSON.parse(localStorage.getItem('theme'));
      this.lang = localStorage.getItem('language') || 'en';
    },
    mounted() {
        this.getList()
    },
    methods: {
       back(){
           this.$router.push('/index')
       },
       getList(){
           let params = {
               type: 'xinshoubikan'
           }
            this.$ajax.get('/web/getTextsList',{params}).then((res) => {
                let resData = res.data.data;
                if(resData.length > 0){
                    this.xsbkArr = resData;
                    this.curDataLength = resData.length;
                }else{
                    this.curDataLength = resData.length;
                }
                if(this.xsbkArr.length > 0){
                    this.hasData = false;
                }else{
                    this.hasData = true;
                }
            }).catch(function(err){
                console.log(err)
            })
       },
       goDetail(id){
           this.$router.push({ path: '/helpDetail', query: { id: id } })
       }
    },
    components:{
        navBar,
    },
    beforeDestroy(){

    }
}
</script>
<style scoped>
    .head{
        position: fixed;
        top: 0;
        width: 100%;
        height: 1.6rem;
        padding: 0 .44rem;
        color: #000;
        line-height: 1.6rem;
        background: #fff;
        box-sizing: border-box;
        text-align: center;
    }
    .head .back{
        position: absolute;
        left: .4rem;
        top: 50%;
        width: .5rem;
        margin-top: -.4rem;
    }
    .head .title{
        font-size: .56rem;
    }
    .head .text{
        font-size: .48rem;
    }
    .cotainer{
        position: absolute;
        top: 1.6rem;
        bottom: 0;
        width: 100%;
        background: #f9f9f9;
        overflow-y: scroll;
    }
    .cotainer .ul-box{
        padding: 0 .3rem;
        background: #fff;
    }
    .cotainer .ul-box .li{
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: .6rem 0;
        color: #000;
        font-size: .42rem;
        border-bottom: 1px solid #ececec;
    }
    .cotainer .ul-box .li .arrow{
        width: .24rem;
    }
    .cotainer .ul-box .li:last-child{
        border-bottom: none;
    }
</style>



// WEBPACK FOOTER //
// src/pages/help.vue